import { useRestartOnBackAfterSignature } from '../../helpers/Hooks';
import { OutdoorKiosk } from './OutdoorKiosk';

export const ContinueAtKiosk = (props: { onComplete: () => void; }) => {
    useRestartOnBackAfterSignature();
    return <OutdoorKiosk onComplete={props.onComplete} />;
};
